import apiClient, { apiRequest } from "./apiClient";

/**
 * Self-service SFTP delivery access for the logged-in user's org.
 * The backend resolves the tenant from the caller's token, so these calls only
 * ever affect the user's own organization. Backend: /api/v1/sftp/*.
 */
const B = "/api/v1/sftp";

const deliveryAccessService = {
  getAccess: () =>
    apiRequest(() => apiClient.get(`${B}/access`), "Failed to load delivery access"),

  listKeys: () =>
    apiRequest(() => apiClient.get(`${B}/keys`), "Failed to load SSH keys"),

  registerKey: (publicKey, label) =>
    apiRequest(
      () => apiClient.post(`${B}/keys`, { public_key: publicKey, label }),
      "Failed to register SSH key"
    ),

  revokeKey: (fingerprint) =>
    apiRequest(
      () => apiClient.delete(`${B}/keys`, { params: { fingerprint } }),
      "Failed to revoke SSH key"
    )
};

export default deliveryAccessService;
